import styled from 'styled-components'

import { IndexLayoutOldSubtitle } from '@sketch/modules-common'
import { Text } from '@sketch/components'

export const FormContainer = styled.div`
  margin: 24px 0 24px;
`
export const LinkDescription = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.C',
})`
  text-align: center;
  margin-top: 4px;
`

export const Subtitle = styled(IndexLayoutOldSubtitle)`
  max-width: 448px;
  margin: 8px auto 0;
`

export const Wrapper = styled.div`
  height: 100%;
  max-width: 448px;
  width: 100%;
  display: flex;
  flex-direction: column;
`
